import React from 'react';
import { Component } from 'react';
import { useEffect, useState} from 'react';

//import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route, useNavigate, Navigate, useParams} from 'react-router-dom';

import LandingPage from './LandingPage';  // ComingSoon component
import SignUp from './SignUp';  // SignUp component
import Login from './Login';  // SignUp component
import Help from './Help';
import EmailVerification from "./EmailVerification";
import EmailVerified from "./EmailVerified";
import SubscriptionSetup from "./SubscriptionSetup";
import SubscriptionConfirmed from "./SubscriptionConfirmed";
import Licenses from "./Licenses";


// import WebDevelopment from './WebDevelopment';
// import ImageDevelopment from './ImageDevelopment';
import Settings from './Settings';

import Dashboard from './Dashboard';
import Header from './Header';
import Menu from './Menu';
import Footer from './Footer';
import ProtectedRoute from "./ProtectedRoute"; // Import the ProtectedRoute component
import VerifyLink from './VerifyLink'; // Import the VerifyLink component
import ResetPasswordLink from './ResetPasswordLink';
import RegistrationComplete from './RegistrationComplete';
import CreateTemplate from './ait/CreateTemplate';
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import 'katex/dist/katex.min.css'; // Import KaTeX CSS


import Swal from 'sweetalert2';

import Util from './ait/Util.js';
import './Styles.css'; // Importing the CSS file

import 'bootstrap/dist/css/bootstrap.css';



const TApp = () => {

    const [loading, setLoading]=useState(true);
    const [menuEnabled, setMenuEnabled]=useState(true);
    const [isMobile, setIsMobile] = useState(false);
    

    useEffect(() => {
        const validateSession = async () => 
        {
            try
            {


                let u = Util.getInstance();
                if(Util.demo === true)
                {              
                    let user = 	{
                        userId: "manis4364@yahoo.com",
                        webId: "manis4364",
                        subscribed:true,
                        stripePeriodEnd: 0,  //unix time stamp
                        autoRenew: false                
                    }

                    let data = {isAuthenticated:true, user: user}  
                    setAuth(data);
                    setIsLoggedIn(true);
                    return;                    
                }

                const command = Util.serverName + "/protected/validateLogin"; // Base API endpoint
                const response = await fetch(command, {credentials: "include"});
                
                console.log("validateSession");
                if(response.ok)
                {
                    const data = await response.json();
                    console.log(JSON.stringify(data));
                    setAuth(data);
                    setIsLoggedIn(true);
                }
                else
                {
                    setIsLoggedIn(false);
                }                
            }
            catch (err)
            {
                console.log("Error validating session",err);
                setIsLoggedIn(false);

            } 
            finally
            {
                setLoading(false);
            }
        };

        const check = () => {
            const isSmallScreen =
              window.matchMedia("(max-width: 768px)").matches;
        
            const hasTouch =
              "ontouchstart" in window ||
              navigator.maxTouchPoints > 0;
        
            const hasFinePointer =
              window.matchMedia("(pointer: fine)").matches;
        
            const hasHover =
              window.matchMedia("(hover: hover)").matches;
        
            // Likely touch-first device (not desktop-primary)
            const isTouchFirst =
              hasTouch && !(hasFinePointer && hasHover);
        
            const isSmall = isSmallScreen || isTouchFirst;
        
            setIsMobile(isSmall);
          };
  

          /*
        const refreshInterval = 6*60*60*1000; // 6 hours
        
        console.log("Right before setTimeout");
        const timeout = setTimeout(()=>{
            console.log("setTimeout = ", refreshInterval);
            window.location.reload();
        },refreshInterval);
        */
        validateSession();
        setMediaScreen();

        const now = Date.now();
        const lastReload = localStorage.getItem("lastReload");

        const sixHours = 6 * 60 * 60 * 1000;

        if (!lastReload || now - parseInt(lastReload) > sixHours) 
        {
            localStorage.setItem("lastReload", now.toString());            
        }

        // Optional: check again on tab focus
        const handleVisibilityChange = () => {
                if (document.visibilityState === "visible") 
                {
                    const last = parseInt(localStorage.getItem("lastReload") || "0");
                    if (Date.now() - last > sixHours) 
                    {
                            window.location.reload();
                    }
                }
            };

        document.addEventListener("visibilitychange", handleVisibilityChange);

        check();
        window.addEventListener("resize", check);


        return () => {
            console.log("Clearing Timout");
            // clearTimeout(timeout);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("resize", check);
            }
        
    }, []); // Equivalent to componentDidMount, runs only once
 
    const [isLoggedIn, setIsLoggedIn] = useState(false); // State to track login status
    const [isSignedUp, setIsSignedUp] = useState(0);
    const [auth, setAuth] = useState({authenticated:false, user:undefined, globals:undefined});

    const handleMenuEnabled = (flag) =>
    {
        console.log("Menu enabled state",flag);
        setMenuEnabled(flag);
    }


    const logOutFunc = async () => {
    
        const command = Util.serverName + "/protected/logOut"; // Base API endpoint
    
        try {
          // Make the API call using POST method with a JSON body
          const response = await fetch(command, {
            method: 'POST', // Use POST method
            headers: { 'Content-Type': 'application/json' }, // Specify JSON format
            // body: JSON.stringify({ email: emailStr, password }), // JSON payload
          });
    
          const data = await response.json(); // Parse the JSON response
    
          if (!response.ok) {
            // Handle HTTP errors
            // console.log("Response: "+response.message);
            // console.log("ResponseData: "+data.message);
            // throw new Error(data.msg || 'Something went wrong');
    
            console.log(data.message);
            setIsLoggedIn(false); // Set logged-out state to false
            return;
          }
    
          if (!data.status) {
            // Handle application-specific errors (e.g., if `status` is false)
            console.log(data.message);
            setIsLoggedIn(false); // Set logged-out state to false
            return;
            // throw new Error(data.msg);
          }

          console.log(data.message);
          setIsLoggedIn(false); // Set logged-out state to false
    
          
        } catch (error) {
          // Set the error message to be displayed to the user
  
        } finally {
          // Always remove the loading state, whether the request succeeded or failed  
        }
      };
    

    const handleSignup = (state) => 
    {
        console.log("Signup state: " + state);
        setIsSignedUp(state); // Set logged-in state to true

        setIsLoggedIn(false); // Set logged-in state to true
    };

    const handleLogin = (userObj, globals) => {
        
        let authObj = {authenticated:true, user:userObj, globals:globals};
        setAuth(authObj);    

        console.log("Calling handleLogin");
        // console.log(JSON.stringify(authObj));

        setIsLoggedIn(true); // Set logged-in state to true
    };

    const handleLogout = async () => {

        await logOutFunc();

        let authObj = {authenticated:false, user:undefined, globals:undefined};
        setAuth(authObj);    

        // setIsLoggedIn(false); // Set logged-out state to false
    };

    if(loading)
    {
        return <div>Loading...</div>
    }

    return (
        <Router>
            <Routes>
                {/* Public Routes */}
                {!isLoggedIn && (
                    <>
                        <Route path="/" element={<LandingPage />} />
                        <Route path="/login" element={
                                        <GoogleReCaptchaProvider reCaptchaKey='6LenSSYsAAAAAP8tfvjeUHxFaj0squzBOeCukSdc'>
                                            <Login onLogin={handleLogin} onSignup={handleSignup}/>
                                        </GoogleReCaptchaProvider>       
                                        }  />
                        <Route path="/signup" element={
                                        <GoogleReCaptchaProvider reCaptchaKey='6LenSSYsAAAAAP8tfvjeUHxFaj0squzBOeCukSdc'>
                                            <SignUp onSignup={handleSignup}/>
                                        </GoogleReCaptchaProvider>
                                    } />                        
                        <Route path="/registered" element={<RegistrationComplete />} />
                        <Route path="/emailv/:token" element={<VerifyLink />} />
                        <Route path="/reset/:token" element={<ResetPasswordLink isLoggedIn={isLoggedIn}/>} />
                    </>
                )}

                {/* Protected Routes */}
                {isLoggedIn && (
                    <>

                        <Route path="/emailv/:token" element={<VerifyLink />} />
                        <Route path="/reset/:token" element={<ResetPasswordLink isLoggedIn={isLoggedIn} onLogout={handleLogout}/>} />

                        <Route path="/email-verification" 
                            element={
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled} />
                                        <div className="main-content">                                    
                                            <EmailVerification auth={auth} onLogout={handleLogout}/>
                                        </div>
                                        <Footer />
                                </div>
                            } 
                        />
                        <Route path="/email-verified" 
                            element={
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">                                    
                                            <EmailVerified/>
                                        </div>
                                        <Footer />
                                </div>
                            } 
                        />
                        <Route path="/subscription-setup" 
                            element={
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">                                    
                                            <SubscriptionSetup auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        </div>
                                        <Footer />
                                </div>
                            } 
                        />
                        <Route path="/subscription-confirmed" 
                            element={
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">                                    
                                            <SubscriptionConfirmed/>
                                        </div>
                                        <Footer />
                                </div>
                            } 
                        />
                        <Route
                            path="/dashboard"
                            element={                                
                                <ProtectedRoute isLoggedIn={isLoggedIn} isSignedUp={isSignedUp} auth={auth} onLogout={handleLogout}>
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">
                                            
                                            <Dashboard auth={auth} onLogout={handleLogout} onAuth={setAuth} />
                                        </div>
                                        <Footer />
                                    </div>
                                </ProtectedRoute>
                            }
                        />
                        <Route
                            path="/create-template"
                            element={
                                isMobile ? (
                                    <div>
                                        <Header 
                                            auth={auth} 
                                            onAuth={setAuth} 
                                            onLogout={handleLogout}
                                        />
                                        <Menu 
                                            isLoggedIn={isLoggedIn} 
                                            onLogout={handleLogout} 
                                            isEnabled={menuEnabled}
                                        />
                                        <MobileBlocked />
                                        <Footer />
                                    </div>
                                ) : (
                                <ProtectedRoute isLoggedIn={isLoggedIn} isSignedUp={isSignedUp} auth={auth} onLogout={handleLogout}>
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout} />
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">
                                            
                                            
                                            <CreateTemplate auth={auth} onLogout={handleLogout} onAuth={setAuth} demo={Util.demo} />
                                        </div>
                                        <Footer />
                                    </div>
                                </ProtectedRoute>)
                            }
                        />
                        <Route
                            path="/settings"
                            element={
                                <ProtectedRoute isLoggedIn={isLoggedIn} isSignedUp={isSignedUp} auth={auth} onLogout={handleLogout}>
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">
                                            <Settings auth={auth} onLogout={handleLogout}/>
                                        </div>
                                        <Footer />
                                    </div>                                    
                                </ProtectedRoute>
                            }
                           />
                            <Route
                            path="/licenses"
                            element={
                                <ProtectedRoute isLoggedIn={isLoggedIn} isSignedUp={isSignedUp} auth={auth} onLogout={handleLogout}>
                                    <div>
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>
                                        <div className="main-content">
                                            <Licenses/>
                                        </div>
                                        <Footer />
                                    </div>                                    
                                </ProtectedRoute>
                            }
                           />

                            <Route 
                                path="/help" 
                                element={
                                    <ProtectedRoute isLoggedIn={isLoggedIn} isSignedUp={isSignedUp} auth={auth} onLogout={handleLogout}>
                                    <div>          
                                        <Header auth={auth} onAuth={setAuth} onLogout={handleLogout}/>
                                        <Menu isLoggedIn={isLoggedIn} onLogout={handleLogout} isEnabled={menuEnabled}/>                                        
                                        <div className="main-content">                                        
                                            <Help/>                                        
                                        </div>                                    
                                        <Footer />                                                                                  
                                    </div>
                                </ProtectedRoute>
                                } />
         

                        <Route path="/:webId" element={<UserSiteResolver auth = {auth}/>} />
                    </>
                )}

                {/* Fallback Route */}                
                <Route path="*" element={<Navigate to={isLoggedIn ? "/create-template" : "/"} />} />
            </Routes>
        </Router>
    );
};


function UserSiteResolver({auth}) {
    const { webId } = useParams();
    const [valid, setValid] = useState(null);
      
    // console.log("logged in: ", auth?.user?.webId);
    // console.log("Entered: ", webId);

    if(auth?.user?.webId === webId || webId === 'userfonts' || webId === 'three' || webId === 'licenses')
    {
        
        setValid(true);
    }
  
    if (valid) {
      // Let browser go to backend/static site
      window.location.href = `/${webId}/`;
      return null;
    }
  
    return <Navigate to="/create-template" />;
  }

const MobileBlocked = () => {
    return (
      <div style={{
        display: "flex",
        height: "100vh",
        justifyContent: "center",
        alignItems: "center",
        flexDirection: "column",
        textAlign: "center",
        padding: "20px"
      }}>
        <h2>Desktop Recommended</h2>
        <p>
          This app works best on a desktop or larger screen. A keyboard and a three button mouse with a scroll wheel is also needed.          
        </p>
        <p>
          Please visit this page on a laptop or desktop browser.
        </p>
      </div>
    );
  };



function setMediaScreen()
{
    var x = window.matchMedia("(max-width: 500px)");
    if(x.matches)
    {
        Util.mediaScreen=true;
        let u = Util.getInstance();
        if(navigator.userAgent.indexOf("Firefox") != -1)
        {
            // u.setCookie("useSim",true,365);        
        }
        else
        {
            // u.setCookie("useSim",true,365);        
        }
    }
    else
    {
        Util.mediaScreen=false;
    }
}

  

export default TApp;
